<template>
  <div class="modal-overlay">
    <div class="modal-background" @click="$emit('closeModal')" />
    <div class="modal">
      <h1 class="modal-title">
        {{ Object.values(form).length ? adminText('organizationAll.update_your_organization_ba190ae4', 'Update your organization') : adminText('organizationAll.create_new_organization_64f1481b', 'Create new organization') }}
      </h1>
      <h2 class="title modal-subtitle">{{ adminText('organizationAll.organization_info_3dcdfa7c', 'Organization info') }}</h2>
      <organization-info-form :initial-values="form" :vs="vs" />
      <div class="spacer" />
      <organization-finance-info-form :initial-values="form" :vs="vs" />
      <div class="buttons">
        <main-button class="back-btn" flat :text="adminText('organizationAll.cancel_1507c40f', 'CANCEL')" @click="$emit('closeModal')" />
        <main-button class="continue-btn" depressed @click="$emit('submit')">
          <span>{{ adminText('organizationAll.submit_3fa4054f', 'submit') }}</span>
        </main-button>
      </div>
    </div>
  </div>
</template>

<script>
import OrganizationLocalization from '@/components/organizations/organization-all-display'

import organizationInfoForm from './organization-info-form.vue'
import organizationFinanceInfoForm from './organization-finance-info-form.vue'

export default {
  mixins: [OrganizationLocalization],
  name: 'initial-organization-update-modal',
  components: { organizationInfoForm, organizationFinanceInfoForm },
  props: {
    initialValues: {
      type: Object,
      default: () => {},
    },
    vs: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      form: this.initialValues,
    }
  },
  watch: {
    form: {
      handler(val) {
        this.$emit('values', val)
      },
      deep: true,
    },
  },
}
</script>

<style scoped>
.modal-overlay {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 999;
}
.modal-background {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: #00000050;
}
.modal {
  text-align: left;
  background-color: white;
  height: 70%;
  width: 100%;
  position: relative;
  max-width: 40.75rem;
  padding: 2rem;
  border-radius: 20px;
  overflow-y: auto;
  -ms-overflow-style: none;
  scrollbar-width: none;
  z-index: 1;
}
.modal::-webkit-scrollbar {
  display: none;
}
.spacer {
  height: 1.5rem;
}
.modal-title {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 700;
  font-size: 32px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 2rem;
}
.modal-subtitle {
  font-family: 'Raleway';
  font-style: normal;
  font-weight: 500;
  font-size: 20px;
  letter-spacing: -0.03em;
  font-feature-settings: 'pnum' on, 'lnum' on;
  color: #ff4c00;
  margin-bottom: 1.5rem;
}
.finance-description {
  font-family: 'Source Sans Pro';
  font-style: normal;
  font-weight: 400;
  font-size: 18px;
  color: #979797;
}
.buttons {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
@media screen and (max-width: 700px) {
  .modal {
    width: 100%;
    max-width: 100%;
    height: 100%;
    border-radius: 0;
  }
}
</style>
